import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../utils/service";
import { store } from "../../../utils/store";

function selectedOrganizationId() {
  const orgId = store.getState().auth.activeOrganizationId;
  if (!orgId || orgId === "all" || orgId === "*") return "all";
  return String(orgId);
}

export async function getUnmergeLeadList(payload: {
  page?: number;
  limit?: number;
  search?: string;
  source?: string;
  status?: "pending" | "done" | "all";
  uniqueOnly?: boolean;
  sortBy?: string;
  sortDir?: "asc" | "desc";
}) {
  const callParams = await getCallParams("GET");
  const qs = new URLSearchParams({
    page: String(payload.page ?? 0),
    limit: String(payload.limit ?? 25),
    search: payload.search || "",
    source: payload.source || "",
    status: payload.status || "pending",
    uniqueOnly: payload.uniqueOnly ? "1" : "0",
    sortBy: payload.sortBy || "createdAt",
    sortDir: payload.sortDir || "desc",
    organizationId: selectedOrganizationId(),
  });
  return makeCall(`${urls.GETUNMERGELEADLIST}?${qs.toString()}`, callParams);
}

export async function promoteUnmergeLeads(payload: {
  ids?: string[];
  allPending?: boolean;
  allMatching?: boolean;
  source?: string;
  search?: string;
  limit?: number;
}) {
  const callParams = await getCallParams("POST", {
    ...payload,
    organizationId: selectedOrganizationId(),
  });
  // Bulk promote can take a few minutes for large batches
  return makeCall(urls.PROMOTEUNMERGELEADS, callParams, 300000);
}
